<div class="modal-header">
  <h5 class="modal-title">{{ 'importProgress.title' | transloco }}</h5>
</div>

<div class="modal-body">
  <!-- Overall Progress -->
  <div class="overall-progress">
    <div class="d-flex justify-content-between align-items-center mb-1">
      <h6 class="mb-0">{{ 'importProgress.overallProgress' | transloco }}</h6>
      <span class="text-muted small">{{ overallProgress() }}%</span>
    </div>
    <ngb-progressbar
      [value]="overallProgress()"
      [type]="getProgressType(overallProgress())"
      [striped]="true"
      [animated]="overallProgress() < 100"
      height="16px"
    ></ngb-progressbar>
    <p class="text-muted small mt-1 mb-0">
      {{ progressMessage() || currentStep() }}
      @if (currentStep() === 'Finalizing import') {
        <span class="finalizing-loader">
          <span></span>
          <span></span>
          <span></span>
        </span>
      }
    </p>
  </div>

  <!-- Import Steps -->
  <div class="import-steps">
    <h6 class="mb-3">{{ 'importProgress.importSteps' | transloco }}</h6>

    @for (step of importSteps(); track step.name) {
      <div class="import-step" [ngClass]="getStepClass(step)">
        <div class="d-flex align-items-start">
          <div class="step-icon me-2">
            <app-feather-icon
              [icon]="getStepIcon(step)"
              style="width: 18px; height: 18px"
              [class.spin]="step.status === 'in-progress'"
              [class.pulse]="step.status === 'waiting'"
            ></app-feather-icon>
          </div>

          <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <span class="step-name small">{{ step.name }}</span>
              @if (step.status === 'skipped') {
                <span class="text-muted small">
                  {{ 'importProgress.skipped' | transloco }} {{ getSkipReason(step) }}
                </span>
              } @else if (
                step.status === 'waiting' ||
                (step.status === 'pending' && step.dependencies && step.dependencies.length > 0)
              ) {
                <!-- CRITICAL: Show waiting message for waiting status OR pending status with dependencies -->
                <!-- This handles cases where backend sends "pending" instead of "waiting" -->
                <span class="text-muted small">{{ getWaitingMessage(step) }}</span>
              } @else if (
                step.status === 'pending' && step.processedItems === 0 && (!step.totalItems || step.totalItems === 0)
              ) {
                <span class="text-muted small">{{ 'importProgress.readyToStart' | transloco }}</span>
              } @else if (
                step.processedItems !== undefined &&
                (step.status === 'pending' ||
                  step.status === 'in-progress' ||
                  step.status === 'completed' ||
                  step.status === 'error')
              ) {
                <!-- Only show processedItems/totalItems if status is NOT waiting or skipped, and has no dependencies -->
                <span class="text-muted small">
                  @if (step.totalItems !== undefined && step.totalItems !== null && step.totalItems > 0) {
                    {{ step.processedItems }} / {{ step.totalItems }}
                  } @else {
                    {{ step.processedItems }} {{ 'importProgress.processed' | transloco }}
                  }
                </span>
              }
            </div>

            @if (step.status === 'in-progress' || step.status === 'completed') {
              <ngb-progressbar
                [value]="step.progress"
                [type]="step.status === 'completed' ? 'success' : 'in-progress'"
                [striped]="true"
                [animated]="step.status === 'in-progress'"
                height="6px"
              ></ngb-progressbar>
            } @else if (step.status === 'waiting') {
              <div class="waiting-loader">
                <div class="waiting-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <!-- Info Message -->
  <div class="alert alert-info">
    <app-feather-icon [icon]="'info'" class="me-1"></app-feather-icon>
    <span class="small">{{ getTimeEstimateMessage() }}. {{ 'importProgress.backgroundHint' | transloco }}</span>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">
    {{ 'importProgress.runInBackground' | transloco }}
  </button>
</div>
